export const FACEBOOK = "F";

export const links = {
  [FACEBOOK]: "https://www.facebook.com/BrotherbearDFW/",
};
